import { JsonObject } from 'ta-json';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_colorCodes,
} from '@src/app/generated/GetAllRetailers';
import { ColorCodesInput } from '@src/app/generated/globalTypes';
import { ColorCodes } from '@ess/jg-rule-executor';

/**
 * Retailer options
 */
@JsonObject()
export class PortalColorCodes extends ColorCodes {
  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_colorCodes): PortalColorCodes {
    return new PortalColorCodes(
      gql.button,
      gql.buttonPrimaryHover,
      gql.buttonSecondaryHover,
      gql.gradient1,
      gql.gradient2,
      gql.cartButton,
      gql.cartButtonHover,
      gql.background,
      gql.selectedItemBackground,
      gql.bodyText,
      gql.headerText,
      gql.selectedItem,
      gql.icons,
      gql.activeStep,
      gql.inactiveStep,
      gql.dropShadow,
      gql.warn,
      gql.border
    );
  }

  toGqlInput(): ColorCodesInput {
    return {
      button: this.button,
      buttonPrimaryHover: this.buttonPrimaryHover,
      buttonSecondaryHover: this.buttonSecondaryHover,
      gradient1: this.gradient1,
      gradient2: this.gradient2,
      cartButton: this.cartButton,
      cartButtonHover: this.cartButtonHover,
      background: this.background,
      selectedItemBackground: this.selectedItemBackground,
      bodyText: this.bodyText,
      headerText: this.headerText,
      selectedItem: this.selectedItem,
      icons: this.icons,
      activeStep: this.activeStep,
      inactiveStep: this.inactiveStep,
      dropShadow: this.dropShadow,
      warn: this.warn,
      border: this.border,
    };
  }
}
